<script setup>
import { ref } from 'vue';
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid'

// Podrías pasar contenido HTML como una prop si deseas controlar el contenido HTML dinámicamente
const props = defineProps({
    info: String
});
</script>
<template>
    <div class="border-l-4 border-yellow-400 bg-yellow-50 p-4">
        <div class="flex items-center">
            <div class="flex-shrink-0">
                <ExclamationTriangleIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
            </div>
            <div class="ml-3">
                <p class="text-sm text-yellow-700">
                    <slot>
                        <span v-html="info"></span>
                    </slot>
                </p>
            </div>
        </div>
    </div>
</template>
  
  